import { theme } from '_constants/theme';
import styled from 'styled-components';
import React from 'react';
import { ICONS_ALIASES } from '_constants/icons';
import Icon from '_components/atomic/Icon';

const { colors, devices, fontSizes, spaces } = theme;

const StyledWhyAboutRight = styled.div`
  .listRightTrademark {
    padding: ${spaces.large4X}px;
    background-color: ${colors.white};
    box-shadow: 0px 10px 80px rgba(0, 0, 0, 0.05);
    border-radius: 50px;
    width: 100%;
    gap: ${spaces.medium}px;
    display: flex;
    flex-direction: column;
  }
  .footerAbout {
    margin-top: 30px;
    text-align: justify;
    font-family: 'Aeonik';
    font-style: italic;
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    /* Gray/700 */
    color: #344054;
  }
  @media ${devices.tablet} {
    .listRightTrademark {
      border-radius: 0px;
      padding: 0;
      padding: ${spaces.regular}px;
      background: ${colors.white};
    }
    .footerAbout {
      margin-top: ${spaces.regular}px;
      padding-left: ${spaces.regular}px;
      padding-right: ${spaces.regular}px;
      font-size: ${fontSizes.regular}px;
    }
  }
`;
const StyledProduct = styled.div`
  display: flex;
  align-items: center;
  gap: ${spaces.medium}px;
  background: ${({ color }) => color};
  border-radius: 16px;
  padding: ${spaces.medium}px;
  flex-direction: row;
  svg {
    width: 40px;
    height: 40px;
  }
  .description {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 500;
    font-size: ${fontSizes.large}px;
    line-height: 150%;
    color: ${({ textColor }) => textColor};
  }
  @media ${devices.tablet} {
    svg {
      width: 32px;
      height: 32px;
    }
    .description {
      font-size: ${fontSizes.regular}px;
    }
  }
`;
const products = [
  {
    header: 'Trademark Registration',
    icon: `${ICONS_ALIASES.edit}`,
    color: `${colors.blue[50]}`,
    textColor: `${colors.blue[500]}`,
  },
  {
    header: 'Trademark Searches',
    icon: `${ICONS_ALIASES.searchZoomIn}`,
    color: `${colors.purple[25]}`,
    textColor: `${colors.purple[500]}`,
  },
  {
    header: 'Trademark Monthly Monitoring',
    icon: `${ICONS_ALIASES.deviceMessage}`,
    color: `${colors.orange[25]}`,
    textColor: `${colors.orange[500]}`,
  },
  {
    header: 'Office Action Responses',
    icon: `${ICONS_ALIASES.smsEdit}`,
    color: `${colors.indigo[25]}`,
    textColor: `${colors.indigo[500]}`,
  },
  {
    header: 'Statement of Use Filing',
    icon: `${ICONS_ALIASES.archive}`,
    color: `${colors.green[25]}`,
    textColor: `${colors.green[500]}`,
  },
  {
    header: 'and many more...',
    icon: `${ICONS_ALIASES.more}`,
    color: `${colors.gray[25]}`,
    textColor: `${colors.gray[500]}`,
  },
];
const RightPartWhyAboutSection = () => {
  return (
    <StyledWhyAboutRight>
      <div className="listRightTrademark">
        {products.map((step, idx) => {
          const { header, icon, color, textColor } = step;
          return (
            <StyledProduct key={idx} color={color} textColor={textColor}>
              <div>
                <Icon alias={icon} color={textColor} />
              </div>
              <div className="description">{header}</div>
            </StyledProduct>
          );
        })}
      </div>
      <div className="footerAbout">
        We do not operate as a law firm. No information on our website is to be
        used as legal advice. Each situation is handled specific to the
        owner&#39;s needs, meaning all outcomes are variable.
      </div>
    </StyledWhyAboutRight>
  );
};

export default RightPartWhyAboutSection;
